import React from 'react';
import PropTypes from 'prop-types';

const AnnouncementsActions = ({ onSendTest, onSendMessage, canSendTest, canSend, isSending }) => (
  <div className='announcements-actions'>
    <button type='button' className='announcements-btn announcements-btn-secondary' onClick={onSendTest} disabled={!canSendTest || isSending}>
      Send Test
    </button>
    <button type='button' className='announcements-btn announcements-btn-primary' onClick={onSendMessage} disabled={!canSend || isSending}>
      {isSending ? 'Sending…' : 'Send Message'}
    </button>
  </div>
);

AnnouncementsActions.propTypes = {
  onSendTest: PropTypes.func.isRequired,
  onSendMessage: PropTypes.func.isRequired,
  canSendTest: PropTypes.bool.isRequired,
  canSend: PropTypes.bool.isRequired,
  isSending: PropTypes.bool.isRequired
};

export default AnnouncementsActions;
